import React from 'react';
import { TextArea, Dropdown } from 'semantic-ui-react'

import ControlTagsDropdown from './control_tags_dropdown'

import { getText } from '../../helpers';

export default function RisksComparisonMenu(props) {
  const { showFilterByPlans, showFilterByControlTags } = props;
  const searchClassName = showFilterByPlans && showFilterByControlTags ? "search-controls-input" : "search-controls-input full-width";
  return (
    <div className="risks-comparison-menu">
      <div className={searchClassName}>
        <label>{getText("Search Controls")} </label>
        <TextArea
          icon='search'
          placeholder={`${getText("Search Controls")}...`}
          value={props.searchTerm}
          onChange={props.onSearchChange}
        />
      </div>
      {
        showFilterByPlans &&
        <div className="filter-by-plan-dropdown">
          <label>{getText("Filter by Plans")} </label>
          <Dropdown
            id="filter-by-plan-dropdown"
            placeholder={getText("Filter by Plans")}
            options={props.planDropdownOptions}
            value={props.selectedPlanIds}
            onChange={props.onPlanDropdownChange}
            fluid
            multiple
            search
            selection
            closeOnBlur
            closeOnChange
          />
        </div>
      }
      {
        showFilterByControlTags &&
        <div className="filter-by-controls-tags-dropdown">
          <label>{getText("Filter by Control Tags")} </label>
          <ControlTagsDropdown
            placeholder={getText("Filter by Control Tags")}
            onTagsChange={props.onTagsChange}
          />
        </div>
      }
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/views/risks_comparison/risks_comparison_menu.js